var _a;
/**
 * Visual configuration for authority record types.
 * Centralizes colors, gradients, and MARC tags so they can be reused
 * across AuthorityTypeCard, badges, lists, and other components.
 */
import { RecordType } from '../../types/api';
export var AUTHORITY_TYPE_CONFIG = (_a = {},
    _a[RecordType.PERSONAL] = {
        gradientFrom: '#1565c0',
        gradientTo: '#42a5f5',
        borderColor: '#1976d2',
        marcTag: '100',
    },
    _a[RecordType.CORPORATE] = {
        gradientFrom: '#2e7d32',
        gradientTo: '#66bb6a',
        borderColor: '#388e3c',
        marcTag: '110',
    },
    _a[RecordType.MEETING] = {
        gradientFrom: '#e65100',
        gradientTo: '#ffb74d',
        borderColor: '#f57c00',
        marcTag: '111',
    },
    _a[RecordType.UNIFORM_TITLE] = {
        gradientFrom: '#b71c1c',
        gradientTo: '#ef5350',
        borderColor: '#c62828',
        marcTag: '130',
    },
    _a[RecordType.CHRONOLOGICAL] = {
        gradientFrom: '#4e342e',
        gradientTo: '#8d6e63',
        borderColor: '#5d4037',
        marcTag: '148',
    },
    _a[RecordType.SUBJECT] = {
        gradientFrom: '#6a1b9a',
        gradientTo: '#ab47bc',
        borderColor: '#7b1fa2',
        marcTag: '150',
    },
    _a[RecordType.GEOGRAPHIC] = {
        gradientFrom: '#004d40',
        gradientTo: '#26a69a',
        borderColor: '#00695c',
        marcTag: '151',
    },
    // CZNA-181: old-print city (Aleph prefix pv, MARC 195). Adapted from the
    // GEOGRAPHIC place palette but shifted to a muted slate so the two
    // place-like types stay visually distinguishable.
    _a[RecordType.OLD_PRINT_CITY] = {
        gradientFrom: '#37474f',
        gradientTo: '#78909c',
        borderColor: '#455a64',
        marcTag: '195',
    },
    _a[RecordType.GENRE_FORM] = {
        gradientFrom: '#0d47a1',
        gradientTo: '#5c6bc0',
        borderColor: '#283593',
        marcTag: '155',
    },
    // TASK-140: conspect group (Aleph prefix sk, MARC 190). A classification
    // grouping rather than a name or a subject heading — given the neutral slate
    // the vocabulary rows used to carry, so it reads as "structural" next to the
    // saturated cataloguing types.
    _a[RecordType.CONSPECT_GROUP] = {
        gradientFrom: '#546e7a',
        gradientTo: '#90a4ae',
        borderColor: '#607d8b',
        marcTag: '190',
    },
    // CZNA-422: name-title authority. Shares the UNIFORM_TITLE red family because
    // both describe a *work*, shifted lighter to keep the two distinguishable.
    // marcTag is null on purpose — see the AuthorityTypeVisual doc above.
    _a[RecordType.AUTHOR_WORK] = {
        gradientFrom: '#ad1457',
        gradientTo: '#f06292',
        borderColor: '#c2185b',
        marcTag: null,
    },
    _a);
